<template>
    <div class="ms-2">

        <div class="dropdown">
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="sortDropdown"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-sort"></i> sort
            </button>
            <div class="dropdown-menu view-options-dropdown" aria-labelledby="sortDropdown">

                <div class="container m-2">
                    <div class="d-flex flex-row">

                        <div class="one-half">
                            <label for="sortFieldOptions">Sort field</label>
                            <select id="sortFieldOptions" name="sortFieldOptions"
                                    class="form-control small-form-control custom-select-sm ps-1"
                                    @click.stop="onFieldSelectClick"
                                    @change="validateSortSelections()"
                                    v-model="view.sort_field_id">
                                <option value="">Clear sort field</option>
                                <option v-for="field in table.fields" :value="field.index">{{field.name}}</option>
                            </select>
                        </div>
                        <div class="one-half mx-2">
                            <label for="sortDirectionOptions">Sort direction</label>
                            <select id="sortDirectionOptions" name="sortDirectionOptions"
                                    class="form-control small-form-control custom-select-sm ps-1"
                                    @click.stop="onFieldSelectClick"
                                    @change="validateSortSelections()"
                                    v-model="view.sort_direction">
                                <option value="ASC">ascending</option>
                                <option value="DESC">descending</option>
                            </select>
                        </div>

                    </div>

                    <div class="mt-2" v-if="view.sort_field_id && view.sort_direction">
                        <a href="javascript:void(0)" class="btn btn-light btn-sm"
                           @click.stop="clearSortSelections">clear</a>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";

    export default {
        name: 'SortDropdown',
        props: ['view', 'table'],
        data () {
            return {
                model: webase.model,
                service: new ViewService()
            }
        },
        mounted () {
        },
        methods: {
            onFieldSelectClick() {
                // need a click event to stop event propogation
            },
            validateSortSelections() {
                if (this.view.sort_field_id && this.view.sort_direction) {
                    this.save()
                }
            },
            clearSortSelections() {
                this.view.sort_field_id = null
                this.view.sort_direction = ''
                this.save()
            },
            save() {
                let request = {
                    view: {
                        sort_field_id: this.view.sort_field_id,
                        sort_direction: this.view.sort_direction
                    }
                }

                this.service.update(this.view.id, request).then((response) => {
                    console.log('Updated view')
                    console.log(response)
                    webase.eventDispatcher.emit('viewUpdated', this.view)
                }).catch((message) => {
                    console.log('error updating view')
                    console.log(message)
                })
            }
        }
    }
</script>

